import { render, staticRenderFns } from "./MaterialTemplate1.vue?vue&type=template&id=2bdffb42"
import script from "./MaterialTemplate1.vue?vue&type=script&lang=js"
export * from "./MaterialTemplate1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports